'use strict';

module.exports = {
  template: require('./set-password.html'),
  controller: require('./set-password.controller'),
  controllerAs: 'vm',
  bindings: {
    invite: '<'
  }
};



/*****************
 ** WEBPACK FOOTER
 ** ./src/app/auth/set-password/index.js
 ** module id = 179
 ** module chunks = 0
 **/